module.exports = __webpack_public_path__ + "media/img/sbt-test/Scholarships2u-English-Test-9608f469aa5a84f3e41021c1c37f68ea.svg";